import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';

export interface DeleteSimulationFilter {
    user?: { id: any; name: string };
    customer?: { id: any; name: string };
    region?: { id: any; name: string };
    project?: { id: any; name: string };
    simulation?: { id: any; name: string };
}

@Injectable({ providedIn: 'root' })
export class DeleteSimulationService {
    private allSimulations: any[] = [];
    private filters: DeleteSimulationFilter = {};

    private filteredSimulationsSubject = new BehaviorSubject<any[]>([]);
    filteredSimulations$ = this.filteredSimulationsSubject.asObservable();

    private selectedSimulationSubject = new BehaviorSubject<any>(null);
    selectedSimulation$ = this.selectedSimulationSubject.asObservable();

    // Http Options
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }


    constructor(private http: HttpClient) { }

    setSimulations(simulations: any[]) {
        this.allSimulations = simulations;
        this.applyFilters();
    }

    setFilters(filters: DeleteSimulationFilter) {
        this.filters = filters;
        this.applyFilters();
    }

    setSelectedSimulation(simulation: any) {
        this.selectedSimulationSubject.next(simulation);
    }

    getSelectedSimulationValue(): any {
        return this.selectedSimulationSubject.getValue();
    }

    checkDeletableLevels(simulationId: number) {
        
        
        const url = `${environment.apiEndpoint}corrosionclas/v1/Tree/validateDeletion/${simulationId}`;
        const resp = this.http.get(url, this.httpOptions).pipe(
            tap((resp: any) => resp),
            catchError(err => {
                throw err.message;
            }));
        return resp;
    }

    private applyFilters() {
        const filtered = this.allSimulations.filter(sim => {
            return (!this.filters.user || sim.user.id === this.filters.user.id)
                && (!this.filters.customer || sim.customer.id === this.filters.customer.id)
                && (!this.filters.region || sim.region.id === this.filters.region.id)
                && (!this.filters.project || sim.project.id === this.filters.project.id)
                && (!this.filters.simulation || sim.id === this.filters.simulation.id);
        });
        this.filteredSimulationsSubject.next([...filtered]);
    }
}